import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react'

type DraggedItem = Record<string, string | number | boolean>

type DragAndDropContextType = {
  draggedItem: DraggedItem
  setDraggedItem: Dispatch<SetStateAction<DraggedItem>>
}
const DragAndDropContext = createContext<DragAndDropContextType>(undefined)

type DragAndDropProviderProps = {
  children: ReactNode
}
function DragAndDropProvider({ children }: DragAndDropProviderProps) {
  const [draggedItem, setDraggedItem] = useState<DraggedItem>()
  return (
    <DragAndDropContext.Provider value={{ draggedItem, setDraggedItem }}>
      {children}
    </DragAndDropContext.Provider>
  )
}

function useDragAndDrop() {
  const ctx = useContext(DragAndDropContext)
  if (!ctx) throw new Error('missing drag-n-drop ctx')

  return ctx
}

export { DragAndDropProvider, useDragAndDrop }
